module.exports = __webpack_public_path__ + "static/media/positive_brand.be0fafe6.svg";